import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Job from '../../../dto/DtoJob'
import { Button, Grid } from '@mui/material'
import FileSelection from '../../../../components/file/FileSelection'
import Input from '../../../../components/forms/Input'
import i18n from 'simple-react-i18n'
import fetch from 'isomorphic-fetch'
import ApplicationConf from '../../../../conf/ApplicationConf'
import {
    callPromisesSequentially,
    checkAuth,
    checkError,
    getAbortSignal,
    getAuthorization,
    getJson,
} from '../../../../utils/ActionUtils'
import { zip } from 'lodash'
import ProgressCard from '../../../../components/card/ProgressCard'
import { useDispatch } from 'react-redux'
import ToastrAction from '../../../../toastr/actions/ToastrAction'

const promiseUpload = (dirPath, filename, content) => {
    return fetch(ApplicationConf.files.system.uploadFile(), {
        method: 'POST',
        headers: getAuthorization(),
        signal: getAbortSignal(),
        body: JSON.stringify({ dirPath, filename, content }),
    }).then(req => checkAuth(req, { 500: r => Promise.reject(r) })).then(getJson).then(checkError)
        .catch(err => {
            if (err.status === 500) {
                return { insert: 0 }
            }
            throw err
        })
}

const uploadFiles = (files, directory, setProgress, onEnd) => {
    const [promises, params] = zip(...files.map(f => [promiseUpload, [directory, f.name, f.content]]))
    callPromisesSequentially(promises, params, setProgress, onEnd)
}

const FTPUploadManuallyJob = ({
    // isEditMode,
    onChangeFilters,
    filters = {},
    onExecute = () => {},
    isEditMode = false,
}) => {
    const dispatch = useDispatch()

    const [selectedFiles, setSelectedFiles] = useState([])
    const [progress, setProgress] = useState(0)
    const [sending, setSending] = useState(false)
    const disabled = !selectedFiles.length || !filters.directory

    const onValidate = () => {
        setSending(true)
        uploadFiles(selectedFiles, filters.directory, setProgress, (results) => {
            setSending(false)
            if (results.every(r => r.insert === 1)) {
                onChangeFilters({ fileNames: selectedFiles.map(f => f.name) }, () => {
                    onExecute()
                })
            } else {
                dispatch(ToastrAction.error(i18n.ftpUploadManuallyError))
            }
        })
    }
    return (
        <Grid container justifyContent='center'>
            <Grid size={3}>
                <Input title={i18n.directory} value={filters.directory} onChange={v => onChangeFilters({ directory: v })} obligatory disabled={!isEditMode}/>
            </Grid>
            <Grid size={12}>
                { sending ? (
                    <ProgressCard progress={progress} withMessage/>
                ) : (
                    <FileSelection files={selectedFiles} setFiles={setSelectedFiles} multiple fileAccept='.xlsx, .xls, .csv, .zip, .txt'/>
                )}
            </Grid>
            <Grid size={12} container justifyContent='center' marginBottom={1} marginTop={1}>
                <Button onClick={onValidate} sx={{ padding: '10 25px', borderRadius: '20px', backgroundColor: disabled ? 'grey' :'primary.main', width: 'auto' }} disabled={disabled}>
                    <Grid sx={{ color: 'white' }} >{i18n.validate}</Grid>
                </Button>
            </Grid>
        </Grid>
    )
}

FTPUploadManuallyJob.propTypes = {
    job: PropTypes.instanceOf(Job).isRequired,
    onChangeFilters: PropTypes.func.isRequired,
    isEditMode: PropTypes.bool,
    filters: PropTypes.shape({}),
    onExecute: PropTypes.func,
}

export default FTPUploadManuallyJob